"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const trans_1 = require("@common/tsutils/trans");
const d3 = __importStar(require("d3"));
let BoxPlot = class BoxPlot extends vue_property_decorator_1.Vue {
    mounted() {
        this.drawChart();
    }
    onChange() {
        this.drawChart();
    }
    onChangeMode() {
        this.drawChart();
    }
    drawChart() {
        const htmlPlot = this.$refs['d3-boxplot'];
        const tooltip = this.$refs['d3-tooltip'];
        const ranksDict = [
            (0, trans_1.trans)('dashboard.insiders.lvls.nd'),
            (0, trans_1.trans)('dashboard.insiders.lvls.vl'),
            (0, trans_1.trans)('dashboard.insiders.lvls.l'),
            (0, trans_1.trans)('dashboard.insiders.lvls.m'),
            (0, trans_1.trans)('dashboard.insiders.lvls.h'),
            (0, trans_1.trans)('dashboard.insiders.lvls.vh'),
        ];
        htmlPlot.innerHTML = '';
        htmlPlot.append(tooltip);
        const clusterHeight = 90;
        const margins = 40;
        const data = this.boxplots;
        const width = htmlPlot.clientWidth;
        const height = clusterHeight * data.length;
        const left_margin = 25;
        let ceilingDomain = 0;
        if (this.mode === '100%') {
            ceilingDomain = this.ceiling;
        }
        if (this.mode === 'custom%') {
            let tempMax = Math.max(...data.map((plot) => plot.density.max));
            tempMax = Math.ceil(tempMax * 1.01 * 200) / 200;
            ceilingDomain = Math.min(1, tempMax);
        }
        if (this.mode === 'real') {
            let tempMax = Math.max(...data.map((plot) => plot.density.max));
            ceilingDomain = Math.ceil(tempMax * 1.02 * 2) / 2;
        }
        const formatNumber = (x) => {
            if (this.mode === 'real') {
                return x.toFixed(2);
            }
            if (this.mode === '100%' && this.ceiling === 100) {
                return Math.round(x).toString();
            }
            if (x < 0.0001)
                return '< 0.01%';
            return (x * 100).toFixed(2) + '%';
        };
        const x = d3
            .scaleLinear()
            .domain([0, ceilingDomain])
            .range([0, width - left_margin]);
        const y = d3
            .scaleLinear()
            .domain([0, data.length - 1])
            .range([height - margins, margins]);
        const svg = d3
            .select(htmlPlot)
            .append('svg')
            .attr('width', width)
            .attr('height', height)
            .attr('class', 'boxplotchart');
        const clusterColors = ['#3FB8B2', '#6C3FB8', '#DB756F', '#CF8944', '#E6C93B'];
        const defs = svg.append('defs');
        const gradient = defs
            .append('linearGradient')
            .attr('id', 'svgGradientArea')
            .attr('y1', '100%')
            .attr('y2', '0%')
            .attr('x1', '0%')
            .attr('x2', '0%')
            .attr('gradientUnits', 'userSpaceOnUse');
        gradient
            .append('stop')
            .attr('class', 'start')
            .attr('offset', '0%')
            .attr('stop-color', '#f3f3f3')
            .attr('stop-opacity', 1);
        for (let i = 0; i < data.length; i++) {
            let spaces = data.length + 1;
            let offset = (100 / spaces) * (i + 1);
            let mycolor = clusterColors[data[i].cluster.idx];
            gradient
                .append('stop')
                .attr('class', 'start')
                .attr('offset', offset + '%')
                .attr('stop-color', mycolor)
                .attr('stop-opacity', 1);
        }
        const main = svg
            .append('g')
            .attr('width', width)
            .attr('height', height)
            .attr('class', 'main');
        let myTickValues = [
            0,
            ceilingDomain / 4,
            (ceilingDomain / 4) * 2,
            (ceilingDomain / 4) * 3,
            ceilingDomain,
        ];
        if (this.mode === '100%' && this.ceiling === 100) {
            myTickValues = [0, 20, 40, 60, 80, 100];
        }
        const x_axis = d3
            .axisBottom(x)
            .tickValues(myTickValues)
            .tickPadding(10)
            .tickFormat(function (d, i) {
            return formatNumber(d);
        });
        main.append('g')
            .attr('class', 'axis axis--x')
            .attr('transform', 'translate(0, ' + height + ')')
            .call(x_axis);
        const y_axis = d3
            .axisLeft(y)
            //.ticks(data.length)
            .tickFormat(function (d, i) {
            if (!Number.isInteger(d))
                return '';
            return data[d].cluster.name_or_default;
        });
        main.append('g')
            .attr('class', 'axis axis--y')
            .attr('transform', `translate(${-left_margin},0)`)
            .call(y_axis);
        // FIX X AXIS AND Y AXIS
        const axisFix = main.append('g');
        axisFix
            .append('rect')
            .attr('class', 'axis axis--y axis--y--fixed')
            .attr('x', function () {
            return -left_margin;
        })
            .attr('y', function (d, i) {
            return 0;
        })
            .attr('fill', 'url(#svgGradientArea)')
            .attr('rx', 5) // how much to round corners - to be transitioned below
            .attr('ry', 5)
            .attr('height', height + 10)
            .attr('width', 10);
        axisFix
            .append('rect')
            .attr('class', 'axis axis--x axis--x--fixed')
            .attr('x', function () {
            return -left_margin;
        })
            .attr('y', function (d, i) {
            return height;
        })
            .attr('rx', 5)
            .attr('ry', 5)
            .attr('height', 10)
            .attr('width', width);
        // Lineas Verticales discontinuas
        const layout = main.append('g').attr('class', 'layout');
        if (this.mode === '100%' && this.ceiling === 100) {
            for (let i = 1; i <= 5; i++) {
                layout
                    .append('line')
                    .attr('height', height)
                    .attr('x1', x((ceilingDomain / 5) * i))
                    .attr('x2', x((ceilingDomain / 5) * i))
                    .attr('y1', height)
                    .attr('y2', 0)
                    .attr('stroke', '#AAA9A9')
                    .attr('stroke-dasharray', 2);
            }
            ranksDict.forEach((rank, i) => {
                if (i !== 0) {
                    layout
                        .append('text')
                        .attr('x', function (d, j) {
                        return x((ceilingDomain / 5) * (i - 1) + ceilingDomain / 5 / 2);
                    })
                        .attr('y', function (d, i) {
                        return -15;
                    })
                        .attr('font-size', '12px')
                        .attr('font-weight', '600')
                        .attr('text-anchor', 'middle')
                        .attr('class', function (d) {
                        return 'bp--' + i;
                    })
                        .text(function (d, j) {
                        return rank.toUpperCase();
                    });
                }
            });
        }
        else {
            for (let i = 1; i <= 4; i++) {
                layout
                    .append('line')
                    .attr('height', height)
                    .attr('x1', x((ceilingDomain / 4) * i))
                    .attr('x2', x((ceilingDomain / 4) * i))
                    .attr('y1', height)
                    .attr('y2', 0)
                    .attr('stroke', '#AAA9A9')
                    .attr('stroke-dasharray', 2);
            }
        }
        // AVG DIFFERENCES
        if (this.show_avgs) {
            const avgs = [];
            layout
                .selectAll('averages')
                .data(data)
                .enter()
                .append('line')
                .attr('x1', function (d, i) {
                avgs.push(d.density.average);
                return x(d.density.average);
            })
                .attr('y1', function (d, i) {
                return y(i) + 15;
            })
                .attr('x2', function (d, i) {
                return x(d.density.average);
            })
                .attr('y2', height + 100)
                .attr('stroke', '#AAA9A9')
                .attr('stroke-dasharray', 2);
            let clusterDominant = '';
            layout
                .append('line')
                .attr('x1', function (d, i) {
                return x(avgs[0]);
            })
                .attr('y1', height + 100)
                .attr('x2', function (d, i) {
                return x(avgs[1]);
            })
                .attr('y2', height + 100)
                .attr('stroke-width', 2)
                .attr('stroke', function () {
                avgs[0] > avgs[1]
                    ? (clusterDominant = clusterColors[1])
                    : (clusterDominant = clusterColors[0]);
                return clusterDominant;
            });
            avgs.forEach((avg, i) => {
                let position = null;
                if (avgs[0] > avgs[1]) {
                    position = avgs[0];
                }
                else {
                    position = avgs[1];
                }
                layout
                    .append('rect')
                    .attr('class', function () {
                    let arrow = 'samples ';
                    if (i == 0) {
                        arrow += 'samples--right_arrow';
                    }
                    if (i == 1) {
                        arrow += 'hide';
                    }
                    return arrow;
                })
                    .attr('x', function (d, j) {
                    return x(position);
                })
                    .attr('y', height + 100)
                    .attr('fill', clusterDominant)
                    .attr('width', 12)
                    .attr('height', 10)
                    .attr('rx', 1)
                    .attr('ry', 1);
            });
        }
        const d3plots = main.append('g').attr('class', 'chartplots');
        // Max and Min
        d3plots
            .selectAll('whiskerboxplot')
            .data(data)
            .enter()
            .append('rect')
            .attr('class', function (d) {
            let base = 'whiskers--rect whiskers--min ';
            let cluster = parseInt(d.cluster.idx) + 1;
            return base + 'whiskers--cluster--' + cluster;
        })
            .attr('x', function (d, i) {
            return x(d.density.min) - 2;
        })
            .attr('y', function (d, i) {
            return y(i) - 7;
        })
            .attr('rx', 2)
            .attr('ry', 2)
            .attr('width', 3)
            .attr('height', 14);
        d3plots
            .selectAll('whiskerboxplot')
            .data(data)
            .enter()
            .append('rect')
            .attr('class', function (d) {
            let base = 'whiskers--rect whiskers--max ';
            let cluster = parseInt(d.cluster.idx) + 1;
            return base + 'whiskers--cluster--' + cluster;
        })
            .attr('x', function (d, i) {
            return x(d.density.max) - 2;
        })
            .attr('y', function (d, i) {
            return y(i) - 7;
        })
            .attr('rx', 2)
            .attr('ry', 2)
            .attr('width', 3)
            .attr('height', 14)
            .attr('fill', function (d) {
            return '#333532';
        });
        const merge_maxmin = (d) => {
            // Difference in pixel from min to max
            const diff_px = x(d.density.max) - x(d.density.min);
            return diff_px < 60;
        };
        d3plots
            .selectAll('whiskerboxplot')
            .data(data)
            .enter()
            .append('text')
            .attr('class', function (d, i) {
            let myclass = 'whisker__text ';
            if (merge_maxmin(d))
                myclass += 'whisker__text--hide';
            return myclass;
        })
            .attr('x', function (d, i) {
            return x(d.density.min) - 20;
        })
            .attr('y', function (d, i) {
            return y(i) + 25;
        })
            .text(function (d) {
            return 'Min ' + formatNumber(d.density.min);
        });
        d3plots
            .selectAll('whiskerboxplot')
            .data(data)
            .enter()
            .append('text')
            .attr('class', function (d, i) {
            let myclass = 'whisker__text';
            return myclass;
        })
            .attr('x', function (d, i) {
            let offset = 20;
            if (merge_maxmin(d))
                offset = 35;
            return x(d.density.max) - offset;
        })
            .attr('y', function (d, i) {
            return y(i) + 25;
        })
            .text(function (d) {
            if (d.density.samples.length <= 1)
                return '';
            if (!merge_maxmin(d)) {
                return 'Max ' + formatNumber(d.density.max);
            }
            else {
                const textMin = formatNumber(d.density.min);
                const textMax = formatNumber(d.density.max);
                if (textMin === textMax)
                    return 'Max & min ' + textMin;
                return 'Min ' + textMin + ' - Max ' + textMax;
            }
        });
        // Box
        d3plots
            .selectAll('whiskerboxplot')
            .data(data)
            .enter()
            .append('rect')
            .attr('class', function (d) {
            let base = 'box ';
            let cluster = parseInt(d.cluster.idx) + 1;
            return base + 'box--cluster--' + cluster;
        })
            .attr('x', function (d, i) {
            return x(d.density.percentil_025);
        })
            .attr('y', function (d, i) {
            return y(i) - 7;
        })
            .attr('width', function (d) {
            return x(d.density.percentil_075 - d.density.percentil_025);
        })
            .attr('height', 14)
            .attr('rx', 3)
            .attr('ry', 3)
            .attr('stroke', function (d) {
            return '#333532';
        })
            .attr('fill', function (d) {
            return '#333532';
        })
            .attr('fill-opacity', function (d) {
            return 0.3;
        });
        // Inner Box
        d3plots
            .selectAll('whiskerboxplot')
            .data(data)
            .enter()
            .append('rect')
            .attr('class', function (d) {
            let base = 'box--inner ';
            let cluster = parseInt(d.cluster.idx) + 1;
            return base + 'box--inner--cluster--' + cluster;
        })
            .attr('x', function (d, i) {
            return x(d.density.percentil_025);
        })
            .attr('y', function (d, i) {
            return y(i) - 7;
        })
            .attr('width', function (d) {
            return x(d.density.percentil_05 - d.density.percentil_025);
        })
            .attr('height', 14)
            .attr('rx', 3)
            .attr('ry', 3)
            .attr('stroke', function (d) {
            return '#333532';
        })
            .attr('fill', function (d) {
            return '#333532';
        })
            .attr('fill-opacity', function (d) {
            return 0.3;
        });
        //Connecting Lines
        d3plots
            .selectAll('whiskerboxplot')
            .data(data)
            .enter()
            .append('line')
            .attr('class', function (d) {
            let base = 'whiskers--line ';
            let cluster = parseInt(d.cluster.idx) + 1;
            return base + 'whiskers--line--cluster--' + cluster;
        })
            .attr('x1', function (d) {
            return x(d.density.min);
        })
            .attr('y1', function (d, i) {
            return y(i);
        })
            .attr('x2', function (d) {
            return x(d.density.percentil_025);
        })
            .attr('y2', function (d, i) {
            return y(i);
        })
            .attr('stroke', function (d) {
            return '#333532';
        })
            .attr('stroke-width', 2);
        d3plots
            .selectAll('whiskerboxplot')
            .data(data)
            .enter()
            .append('line')
            .attr('class', function (d) {
            let base = 'whiskers--line ';
            let cluster = parseInt(d.cluster.idx) + 1;
            return base + 'whiskers--line--cluster--' + cluster;
        })
            .attr('x1', function (d) {
            return x(d.density.percentil_075);
        })
            .attr('y1', function (d, i) {
            return y(i);
        })
            .attr('x2', function (d) {
            return x(d.density.max);
        })
            .attr('y2', function (d, i) {
            return y(i);
        })
            .attr('stroke', function (d) {
            return '#333532';
        })
            .attr('stroke-width', 2);
        // Avg
        d3plots
            .selectAll('whiskerboxplot')
            .data(data)
            .enter()
            .append('circle')
            .attr('class', function (d) {
            let base = 'avg ';
            let cluster = parseInt(d.cluster.idx) + 1;
            return base + 'avg--cluster--' + cluster;
        })
            .attr('cx', function (d, i) {
            return x(d.density.average);
        })
            .attr('cy', function (d, i) {
            return y(i);
        })
            .attr('r', 12)
            .attr('stroke', function (d) {
            return '#ffffff';
        });
        // Avg differences
        if (this.mode === '100%' && this.ceiling === 100) {
        }
        d3plots
            .selectAll('whiskerboxplot')
            .data(data)
            .enter()
            .append('circle')
            .attr('class', function (d) {
            let base = 'avg ';
            let cluster = parseInt(d.cluster.idx) + 1;
            return base + 'avg--cluster--' + cluster;
        })
            .attr('cx', function (d, i) {
            return x(d.density.average);
        })
            .attr('cy', function (d, i) {
            return y(i);
        })
            .attr('r', 8)
            .attr('stroke', function (d) {
            return '#ffffff';
        })
            .attr('stroke-width', 2);
        // AVG TEXT
        d3plots
            .selectAll('whiskerboxplot')
            .data(data)
            .enter()
            .append('text')
            .attr('class', function (d) {
            let base = 'avg--text ';
            let cluster = parseInt(d.cluster.idx) + 1;
            return base + 'avg--text--' + cluster;
        })
            .attr('x', function (d, i) {
            return x(d.density.average);
        })
            .attr('y', function (d, i) {
            return y(i) - 35;
        })
            .style('text-anchor', 'middle')
            .text(function (d, i) {
            if (d.density.samples.length > 1)
                return 'avg ' + formatNumber(d.density.average);
            else
                return formatNumber(d.density.average);
        });
        // BALL IN AXIS
        d3plots
            .selectAll('whiskerboxplot')
            .data(data)
            .enter()
            .append('circle')
            .attr('class', function (d) {
            let base = 'avg ';
            let cluster = parseInt(d.cluster.idx) + 1;
            return base + 'avg--cluster--' + cluster;
        })
            .attr('cx', function (d, i) {
            return -left_margin + 5;
        })
            .attr('cy', function (d, i) {
            return y(i);
        })
            .attr('r', 3)
            .attr('stroke', '#ffffff')
            .attr('stroke-width', 1);
        const show_ranks = this.show_ranks;
        // PRINT SAMPLES
        data.forEach((cluster, i) => {
            const samplesByVal = [];
            cluster.density.samples.forEach((sample, j) => {
                const existingValueIx = samplesByVal.findIndex((sam) => sam.value === sample.value);
                if (existingValueIx !== -1) {
                    samplesByVal[existingValueIx].codes.push(sample.code);
                    samplesByVal[existingValueIx].names.push(sample.name);
                }
                else {
                    let newVal = {
                        value: sample.value,
                        names: [sample.name],
                        codes: [sample.code],
                        rank: sample.rank || -1,
                    };
                    samplesByVal.push(newVal);
                }
            });
            samplesByVal.forEach((samValue, j) => {
                const dimension = this.dimension;
                //cluster.density!.samples.forEach((sample:DensityDataSample, j:number) => {
                d3plots
                    .append('rect')
                    .attr('class', function () {
                    let base = 'samples ';
                    let mycluster = cluster.cluster.idx + 1;
                    return base + 'samples--cluster--' + mycluster;
                })
                    .attr('x', function () {
                    return x(samValue.value) - 8;
                })
                    .attr('y', function () {
                    return y(i) - 30;
                })
                    .attr('width', 15)
                    .attr('height', 12)
                    .attr('rx', 1)
                    .attr('ry', 1)
                    .on('mouseenter', function () {
                    tooltip.style.left = x(samValue.value) - 15 + 'px';
                    tooltip.style.top = y(i) - (show_ranks ? 70 : 25) + 7 + 'px';
                    let classToAdd = 'border--cluster--' + (cluster.cluster.idx + 1);
                    tooltip.classList.add('visible');
                    tooltip.classList.add(classToAdd);
                    let builtName = '';
                    samValue.names.forEach((name, i) => {
                        builtName += name + ' (' + samValue.codes[i] + '), ';
                    });
                    builtName = builtName.trim().slice(0, -1);
                    let tooltiphtml = `<p>${builtName}</p><data>${formatNumber(samValue.value)}</data>`;
                    if (show_ranks && dimension === 'bio') {
                        let rank = ranksDict[0];
                        let classrank = 2;
                        if (samValue.rank) {
                            rank = ranksDict[samValue.rank];
                            classrank = samValue.rank + 2;
                        }
                        if (samValue.rank < 1)
                            rank = (0, trans_1.trans)('dashboard.insiders.lvls.nd');
                        tooltiphtml += `<span class="range__deco--${classrank}">${rank}</span>`;
                    }
                    tooltip.innerHTML = tooltiphtml;
                })
                    .on('mouseout', function () {
                    tooltip.className = 'tooltip';
                });
                if (show_ranks) {
                    d3plots
                        .append('circle')
                        .attr('class', function () {
                        let base = 'range ';
                        //let mycluster = parseInt(cluster.cluster.idx) + 1
                        const rank = samValue.rank;
                        return base + 'range--' + (rank + 2);
                    })
                        .attr('cx', function () {
                        if (samValue.codes.length === 1) {
                            return x(samValue.value) - 0;
                        }
                        else {
                            return x(samValue.value) - 1.75;
                        }
                    })
                        .attr('cy', function () {
                        return y(i) - 12;
                    })
                        .attr('r', 4)
                        .attr('stroke', '#ffffff');
                }
                if (samValue.codes.length > 1) {
                    d3plots
                        .append('circle')
                        .attr('class', function () {
                        let base = 'range ';
                        //let mycluster = parseInt(cluster.cluster.idx) + 1
                        const rank = samValue.rank;
                        return base + 'range--' + (rank + 2);
                    })
                        .attr('cx', function () {
                        return x(samValue.value) + 1.75;
                    })
                        .attr('cy', function () {
                        return y(i) - 12;
                    })
                        .attr('r', 4)
                        .attr('stroke', '#ffffff');
                }
            });
        });
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], BoxPlot.prototype, "boxplots", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], BoxPlot.prototype, "mode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false })
], BoxPlot.prototype, "show_ranks", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true })
], BoxPlot.prototype, "show_avgs", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 1 })
], BoxPlot.prototype, "ceiling", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'bio' })
], BoxPlot.prototype, "dimension", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('boxplots')
], BoxPlot.prototype, "onChange", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('mode')
], BoxPlot.prototype, "onChangeMode", null);
BoxPlot = __decorate([
    (0, vue_property_decorator_1.Options)({})
], BoxPlot);
exports.default = BoxPlot;
